import fetch from "@/uilts/request";


export default {

    getSetting() {
        return fetch.post("SystemSetting/getSetting")
    },
    submitSetting(data) {
        return fetch.post("SystemSetting/submitSetting", data)
    },
    getConfig(data) {
        return fetch.post("Setting/config", data)
    },
}

